import axios from "axios";
import { useDispatch } from "react-redux";
import { getCookie } from "../../helpers/authHelper";
import { getUser } from "../actions/auth";
export const API_URL = "https://sahakari-app-demo.herokuapp.com/api";

export default () => {
//   const dispatch = useDispatch();
  const axiosInstance = axios.create({
    baseURL: API_URL,
  });

  axiosInstance.interceptors.response.use(
    (response) =>
      new Promise((resolve, reject) => {
        resolve(response);
      }),
    (error) => {
      if (!error.response) {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }
      //accesstoken expired..change here
      if (error.response.status === 406) {
        // const refreshToken = getCookie("refreshToken");
        // dispatch(getUser(refreshToken));
        ///retry original request how?
    
      } else {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }
    }
  );

  return axiosInstance;
};


axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });